var bookshelf = require("../index-extended");
require("./Resolution");
require("./Tag");

module.exports = bookshelf.model("ResolutionCatalog", {
  entityName: "ResolutionCatalog",
  entityTimestampable: true,
  entitySync: true,
  entityUuid: true,

  tableName: "resolution_catalog",
  resolutions() {
    return this.hasMany("Resolution");
  },
  tags() {
    return this.belongsToMany("Tag", "resolution_catalog_tag", "resolution_catalog_id", "tag_id");
  },

  format(attrs) {
    delete attrs["$id"];
    delete attrs["resolutions"];
    delete attrs["tags"];

    return attrs;
  },
});
